import React, { useContext, useEffect, useState } from "react";
import Logo from "../../assets/images/clsm-logo.svg";
import NotificationIcon from "../../assets/images/Notification-icon.svg";
import ProfileImage from "../../assets/images/profile-image.jpg";
import { useNavigate } from "react-router";
import { useCookies } from "react-cookie";
import routeConstants from "../../constants/routeConstants.json";
import { userDetailsApi } from "../../api/Api";
import DropDownIcon from "../../assets/images/icons/dropdown-icon.svg";
import SingleUserIcon from "../../assets/images/icons/single-user-icon.svg";
import LogOut from "../../assets/images/icons/logout-icon.svg";
import { logoutApi } from "../../api/Api";
import Dropdown from "react-bootstrap/Dropdown";
import ProfileIcon from "../../assets/images/icons/profile-icon.svg";
import AlertBox from "../AlertComponent/AlertBox";
import LogoutImage from "../../assets/images/logout.svg";
import "./topbar.css";
import { useGlobalContext } from "../../GlobalState/GlobalContext";
import ErrorPopup from "../PopupAlertError/PopupAlertError";
import ContentData from "../../constants/contentFile.json";

const Topbar = () => {
  const { globalProfile, setGlobalProfile } = useGlobalContext();
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const [name, setName] = useState("");
  const [profileImageUrl, setProfileImageUrl] = useState("");
  const [role, setRole] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  const [errorPopup, setErrorPopup] = useState(false);
  const [errorPopupMessage, setErrorPopupMessage] = useState(false);
  const [statusValue, setStatusValue] = useState();
  const [buttonText, setButtonText] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    getUserDetails();
  }, []);

  const handleConfirm = () => {
    setShowAlert(false);
    logoutUser();
  };

  const handleCancelClick = () => {
    setShowAlert(false);
  };

  const getUserDetails = async () => {
    try {
      const userDetails = await userDetailsApi();
      setName(userDetails?.data?.data?.profile?.name);
      setRole(userDetails?.data?.data?.profile?.role?.name);
      setProfileImageUrl(userDetails?.data?.data?.profile?.profileImage);
      setGlobalProfile(userDetails?.data?.data?.profile?.profileImage);
    } catch (error) {
      const responseStatus = error?.response?.data?.statusCode;
      const errorMessage =
        error?.response?.data?.message || ContentData.tenantPage.wentWrong;

      setStatusValue(responseStatus);
      setErrorPopupMessage(errorMessage);
      setErrorPopup(true);

      if (responseStatus === 400) {
        setButtonText(ContentData.tenantPage.tryAgain);
      } else if (responseStatus === 401 || responseStatus === 403) {
        navigate(routeConstants.LOGIN);
        removeCookie("x-access-token");
        setButtonText(ContentData.tenantPage.login);
      } else {
        setButtonText(ContentData.tenantPage.tryAgain);
      }
    }
  };

  const logoutUser = async () => {
    try {
      const userLogout = await logoutApi();
      if (userLogout.status === 200) {
        navigate(routeConstants.LOGIN);
        removeCookie("x-access-token");
        localStorage.clear();
      }
    } catch (error) {
      const responseStatus = error?.response?.data?.statusCode;
      const errorMessage =
        error?.response?.data?.message || ContentData.tenantPage.wentWrong;

      setStatusValue(responseStatus);
      setErrorPopupMessage(errorMessage);
      setErrorPopup(true);

      if (responseStatus === 400) {
        setButtonText(ContentData.tenantPage.tryAgain);
      } else if (responseStatus === 401 || responseStatus === 403) {
        setButtonText(ContentData.tenantPage.login);
        navigate(routeConstants.LOGIN);
        removeCookie("x-access-token");
        localStorage.clear();
      } else {
        setButtonText(ContentData.tenantPage.tryAgain);
      }
    }
  };

  const onClickLogout = () => {
    setShowAlert(true);
  };

  const baseUrl = process.env.REACT_APP_BASE_URL;
  const fullImageUrl = globalProfile ? globalProfile : false;

  return (
    <div className="topbar-page">
      <nav class="navbar fixed-top">
        <a class="navbar-brand">
          <img src={Logo} alt="Logo" height={30} />
          <div className="brand-name"> Load Calculator</div>
        </a>
        <div class="navbar-icons">
          {/* <div
            class="notification"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <img src={NotificationIcon} alt="Notification" />
            <span class="notification-active"></span>
          </div> */}
          <div
            className="profile-icon"
            // onClick={() => {
            //   navigate(routeConstants.VIEW_PROFILE);
            // }}
          >
            {fullImageUrl ? (
              <img
                className="profileIcon"
                src={fullImageUrl}
                alt="Profile Icon"
              />
            ) : (
              <img
                className="profileIcon"
                src={ProfileIcon}
                // alt="Profile Icon"
              />
            )}
            <span class="profile-active"></span>
          </div>
          <div class="user-detail">
            <Dropdown>
              <Dropdown.Toggle
                variant="link"
                id="dropdown-basic"
                className="custom-dropdown-toggle"
              >
                <img
                  src={DropDownIcon}
                  alt="DropDown"
                  // style={{ width: "20px", height: "20px" }}
                />
              </Dropdown.Toggle>

              <Dropdown.Menu
                style={{
                  backgroundColor: "#F7F8FA",
                  paddingLeft: "6px",
                  // paddingRight: "10px",
                  height: "107.23px",
                  width: "184px",
                  marginTop: "14px",
                }}
              >
                <Dropdown.Item
                  className="firstItem"
                  onClick={() => navigate(routeConstants.VIEW_PROFILE)}
                  style={{
                    borderBottom: "1px solid #EDEFF2",
                    color: "#636E72",
                    display: "flex",
                    gap: "10px",
                    height: "50%",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={SingleUserIcon}
                    alt="SingleUser"
                    style={{ height: "23px" }}
                  />
                  View Profile
                </Dropdown.Item>
                <Dropdown.Item
                  // onClick={logoutUser}
                  onClick={onClickLogout}
                  href="#/roles-list"
                  style={{
                    color: "#636E72",
                    display: "flex",
                    gap: "10px",
                    height: "50%",
                    alignItems: "center",
                  }}
                >
                  <img src={LogOut} alt="LogOut" style={{ height: "23px" }} />
                  Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </nav>
      <AlertBox
        show={showAlert}
        setShow={setShowAlert}
        alertMessage={"Are you sure you want to Logout"}
        popImage={LogoutImage}
        handleSubmitData={handleConfirm}
        buttonSubmitText="Confirm"
        handleCancelClick={handleCancelClick}
      />
      <ErrorPopup
        show={errorPopup}
        alertMessage={errorPopupMessage}
        buttonText={buttonText}
        status={statusValue}
        handleCancel={() => setErrorPopup(false)}
        handleSubmit={() => {
          if (statusValue === 401 || statusValue === 403) {
            // goToLogin();
            setErrorPopup(false);
          } else {
            setErrorPopup(false);
            getUserDetails();
          }
        }}
      />
    </div>
  );
};

export default Topbar;
